
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { IFaq } from '@/types';
import { BannerHalfBlurred } from 'components/common/BannerHalfBlurred';
import { Collapsable } from 'components/common/Collapsable';
import { FeatureCard } from 'components/common/FeatureCard';
import { HowItWorksStep } from 'components/common/HowItWorksStep';
import { Icon } from 'components/common/Icon';
import { InfoDot } from 'components/common/InfoDot';
import { Markdown } from 'components/common/Markdown';
import { Meta } from 'components/common/Meta';
import { ScrollLink } from 'components/common/ScrollLink';
import { Separator } from 'components/common/Separator';
import { BannerContent } from 'components/how-it-works/BannerContent';
import { BaseLayout } from 'layouts/BaseLayout';
import { GetStaticProps } from 'next';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { ReactElement, useEffect, useState } from 'react';
import { getApiBasepath } from '../../api';
import routes from '../../constants/routes';
const Guarantee = () => {
    const { t } = useTranslation('how_it_works');
    const router = useRouter();
    const [faqs, setFaqs] = useState<IFaq[]>();
    const getFaqs = async () => {
        const response = await fetch(`${getApiBasepath()}/api/faqs`);
        const data = await response.json();
        const howItWorksFaqs = data.data?.filter((faq: IFaq) => faq.attributes.page === 'GUARANTEE');
        setFaqs(howItWorksFaqs);
    };
    useEffect(() => {
        getFaqs();
    }, []);
    useEffect(() => {
        const { section } = router.query;
        if (section) {
            const target = document.getElementById(String(section));
            target?.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
    }, [router.query]);
    return (<>
      <Meta pageTitle={t('auth_page_title')} pageDescription={t('auth_page_desc')} imageName='social-hiw-authenticity' relativeUrl={routes.howItWorks.guarantee}/>

      <main className='bg-warm-50'>
        <BannerHalfBlurred src='/images/banners/hiw-guarantee.png' priority reversed loading='eager'>
          <BannerContent title={t('guarantee_banner_title')} description={t('guarantee_banner_description')}/>
        </BannerHalfBlurred>

        <section className='bg-warm-50 pb-8 pt-12 sm:pb-12'>
          <div className='container flex justify-center'>
            <div className='w-full max-w-[1120px]'>
              <h6 className='text-center font-medium text-cool-900 md:hidden'>
                {t('8_layers')}
              </h6>
              <h5 className='hidden text-center font-medium text-cool-900 md:block lg:hidden'>
                {t('8_layers')}
              </h5>
              <h4 className='hidden text-center font-medium text-cool-900 lg:block'>
                {t('8_layers')}
              </h4>
              <p className='mt-4 text-center text-sm text-cool-600 md:text-base lg:text-lg xl:text-xl'>
                {t('buy_and_sell')}
              </p>
              <div className='-mx-2 -my-2 mt-8 grid grid-cols-1 items-start md:grid-cols-2 lg:mt-12'>
                <FeatureCard className='col-span-1 mx-2 my-2' iconName='filled-approval' title={t('feature_cards_guarantee.1_title')} shortDescription={<>
                      <p className='mb-4 text-sm text-cool-600 md:text-base'>
                        {t('feature_cards_guarantee.1_description')}
                      </p>
                      <ScrollLink className='cursor-pointer text-secondary-default' to='fairartGuarantee' behavior='smooth'>
                        {t('feature_cards_guarantee.1_long_description_1')}
                      </ScrollLink>
                    </>} hasCollapsable={false}/>
                <FeatureCard className='col-span-1 mx-2 my-2' iconName='filled-inspect' title={t('feature_cards_guarantee.2_title')} shortDescription={<p className='whitespace-pre-wrap'>
                      {t('feature_cards_guarantee.2_description')}
                    </p>} longDescription={<p className='text-sm text-cool-600 md:text-base'>
                      {t('feature_cards_guarantee.2_long_description_1')}
                    </p>}/>
                <FeatureCard className='col-span-1 mx-2 my-2' iconName='filled-profile' title={t('feature_cards_guarantee.3_title')} shortDescription={t('feature_cards_guarantee.3_description')} longDescription={<p className='text-sm text-cool-600 md:text-base'>
                      {t('feature_cards_guarantee.3_long_description_1')}
                    </p>}/>
                <FeatureCard className='col-span-1 mx-2 my-2' iconName='filled-shield' title={t('feature_cards_guarantee.4_title')} shortDescription={<p className='text-sm text-cool-600 md:text-base'>
                      {t('feature_cards_guarantee.4_description')}
                    </p>} longDescription={<p className='text-sm text-cool-600 md:text-base'>
                      {t('feature_cards_guarantee.4_long_description_1')}
                    </p>}/>

                <FeatureCard id='newCondition' className='col-span-1 mx-2 my-2' iconName='filled-new' title={t('feature_cards_guarantee.5_title')} shortDescription={t('feature_cards_guarantee.5_description')} longDescription={<div className='w-full text-sm text-cool-600 md:text-base'>
                      {t('feature_cards_guarantee.5_long_description_1')}
                      <ul className='ml-3 list-inside list-disc'>
                        <li>
                          {' '}
                          {t('feature_cards_guarantee.5_long_description_2')}
                        </li>
                        <li>
                          {' '}
                          {t('feature_cards_guarantee.5_long_description_3')}
                        </li>
                        <li>
                          {' '}
                          {t('feature_cards_guarantee.5_long_description_4')}
                        </li>
                        <li>
                          {' '}
                          {t('feature_cards_guarantee.5_long_description_5')}
                        </li>
                        <li>
                          {' '}
                          {t('feature_cards_guarantee.5_long_description_6')}
                        </li>
                        <li>
                          {' '}
                          {t('feature_cards_guarantee.5_long_description_7')}
                        </li>
                      </ul>
                    </div>}/>

                <FeatureCard className='col-span-1 mx-2 my-2' iconName='filled-paintbrush' title={t('feature_cards_guarantee.6_title')} shortDescription={t('feature_cards_guarantee.6_description')} longDescription={<p className='text-sm text-cool-600 md:text-base'>
                      {t('feature_cards_guarantee.6_long_description_1')}
                    </p>}/>

                <FeatureCard className='col-span-1 mx-2 my-2' iconName='filled-profile' title={t('feature_cards_guarantee.7_title')} shortDescription={t('feature_cards_guarantee.7_description')} longDescription={<p className='whitespace-pre-line text-sm text-cool-600 md:text-base'>
                      {t('feature_cards_guarantee.7_long_description')}
                    </p>}/>

                <FeatureCard className='col-span-1 mx-2 my-2' iconName='box-filled' title={t('feature_cards_guarantee.8_title')} shortDescription={t('feature_cards_guarantee.8_description')} longDescription={<>
                      <p className='whitespace-pre-line text-sm text-cool-600 md:text-base'>
                        {t('feature_cards_guarantee.8_long_description_1')}
                      </p>
                      <p className='mt-4 text-sm text-cool-600 md:text-base [&_a]:text-secondary-default [&_a]:underline'>
                        <Trans i18nKey='how_it_works:feature_cards_guarantee.8_long_description_2' components={{
                link: (<Link href={routes.howItWorks.shipping}></Link>)
            }}/>
                      </p>
                    </>}/>
              </div>
            </div>
          </div>
        </section>

        <div className='container flex justify-center'>
          <Separator className='max-w-[1120px] bg-cool-400'/>
        </div>

        <section id='fairartGuarantee' className='bg-warm-50 pb-12 pt-12 md:pb-16'>
          <div className='container flex flex-col items-center justify-center'>
            <h4 className='hidden text-center font-medium text-cool-900 md:block'>
              {t('the_fairart_guarantee')}
            </h4>
            <h5 className='hidden text-center font-medium text-cool-900 sm:block md:hidden'>
              {t('the_fairart_guarantee')}
            </h5>
            <h6 className='text-center font-medium text-cool-900 sm:hidden'>
              {t('the_fairart_guarantee')}
            </h6>
            <p className='mb-8 mt-2 text-center text-sm text-cool-600 sm:text-base md:mb-12'>
              {t('it_couldnt')}
              <br />
              <span className='font-bold'>{t('get_the_artwork')}</span>
            </p>
            <div className='w-full max-w-[1120px] rounded-lg border border-solid border-cool-300 bg-cool-50 px-8 py-6 md:py-6 lg:px-10 lg:py-10 xl:px-12 xl:py-8'>
              <p className='text-lg font-semibold text-cool-900 sm:hidden'>
                {t('guarantee_applies')}
              </p>
              <h6 className='hidden font-medium text-cool-900 sm:block md:hidden'>
                {t('guarantee_applies')}
              </h6>
              <h5 className='hidden font-medium text-cool-900 md:block'>
                {t('guarantee_applies')}
              </h5>
              <div className='mt-4 text-sm text-cool-700 sm:text-base'>
                <div className='mb-3 flex items-center'>
                  <Icon name='filled-success' filled size={24} className='mr-3 text-success-default '/>
                  <p>{t('the_buyer')}</p>
                </div>
                <div className='mb-4 flex items-start space-x-3'>
                  <Icon name='filled-success' filled size={24} className='text-success-default'/>
                  <div>
                    {t('the_artwork_received')}
                    <ul className='ml-3 list-inside list-disc'>
                      <li>{t('the_seller_sent')}</li>
                      <li>{t('the_artwork_arrives')}</li>
                      <li>{t('the_req_docs')}</li>
                    </ul>
                  </div>
                </div>
                <p>{t('if_you_believe')}</p>
              </div>
            </div>
          </div>
        </section>

        <div className='container flex justify-center'>
          <Separator className='max-w-[1120px] bg-cool-400'/>
        </div>

        <section className='flex justify-center bg-warm-50 pb-12 pt-12 xl:pb-16'>
          <div className='container flex flex-col items-center'>
            <h4 className='mb-14 hidden font-medium sm:block'>
              {t('how_claims_work')}
            </h4>
            <h5 className='mb-14 font-medium sm:hidden'>
              {t('how_claims_work')}
            </h5>
            <div className='mb-6 flex flex-col items-center'>
              <InfoDot className='mb-3 min-h-[32px] w-8 bg-primary-default sm:min-h-[48px] sm:w-12'>
                <h5 className='hidden font-medium text-cool-150 sm:block'>1</h5>
                <h6 className='font-medium text-cool-150 sm:hidden'>1</h6>
              </InfoDot>
              <h5 className='hidden font-medium text-cool-900 sm:block'>
                {t('make_a_claim')}
              </h5>
              <h6 className='font-medium text-cool-900 sm:hidden'>
                {t('make_a_claim')}
              </h6>
            </div>
            <HowItWorksStep src='/files/people-chatting.svg' alt='' description={<div className='flex flex-col text-sm text-cool-600 lg:text-base'>
                  <span>{t('once_you_receive')}</span>
                  <br />
                  <span>{t('claims_are_considered')}</span>
                  <br />
                  <span>{t('there_are_several_ways')}</span>
                  <ul className='ml-3 list-inside list-disc'>
                    <li>
                      <a href='mailto:support@fairart.io'>{t('contact')}</a>
                    </li>
                    <li>{t('go_to_order')}</li>
                    <li>{t('ask_in_live')}</li>
                  </ul>
                  <br />
                  <span>{t('while_reviewing_your_claim')}</span>
                  <br />
                  <span>{t('to_help_us_process')}</span>
                </div>} className='mb-16 max-w-[1120px]'/>

            <div className='mb-8 flex flex-col items-center'>
              <InfoDot className='mb-3 min-h-[32px] w-8 bg-primary-default sm:min-h-[48px] sm:w-12'>
                <h5 className='hidden font-medium text-cool-150 sm:block'>2</h5>
                <h6 className='text-base font-medium text-cool-150 sm:hidden'>
                  2
                </h6>
              </InfoDot>
              <h5 className='hidden font-medium text-cool-900 sm:block'>
                {t('return_and_refund')}
              </h5>
              <h6 className='font-medium text-cool-900 sm:hidden'>
                {t('return_and_refund')}
              </h6>
            </div>

            <div className='flex justify-center'>
              <div className='grid w-full max-w-[1120px] grid-cols-1 space-y-4 md:grid-cols-2 md:space-x-4 md:space-y-0'>
                <div className='w-full rounded-lg border border-solid border-cool-300 bg-cool-50  px-6 py-5 sm:px-12 sm:py-8  lg:px-10 xl:px-12'>
                  <h5 className='mb-6 text-xl font-medium text-cool-900 sm:text-2xl'>
                    {t('as_a_buyer_2')}
                  </h5>
                  <p className='text-sm text-cool-600 md:text-base'>
                    {t('if_your_claim')}{' '}
                    <a href='https://locator.dhl.com/results?language=en&languageCountryCode=GB&resultUom=mi&light=n&countryCode=GB&clientAppCode=gspl&address=SE19TG&capability=81,74' target='_blank' rel='noreferrer' className='text-secondary-default'>
                      {t('thousands')}
                    </a>{' '}
                    {t('or')}{' '}
                    <Link href='/how-it-works/shipping#schedulePickup' className='text-secondary-default'>
                      {t('arrange_collection')}
                    </Link>{' '}
                    {t('within_3_days')} <br /> <br />
                    {t('once_the_item')}
                  </p>
                </div>
                <div className='w-full rounded-lg border border-solid border-cool-300 bg-cool-50  px-6 py-5 sm:px-12 sm:py-8  lg:px-10 xl:px-12'>
                  <h5 className='mb-6 text-xl font-medium text-cool-900 sm:text-2xl '>
                    {t('as_a_seller_2')}
                  </h5>
                  <p className='text-sm text-cool-600 md:text-base'>
                    {t('if_you_fail')} <br /> <br /> {t('you_will_get')} <br />{' '}
                    <br /> {t('if_you_lose')} <br /> <br />{' '}
                    {t('the_buyer_will')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className='container flex justify-center'>
          <Separator className='max-w-[1120px] bg-cool-400'/>
        </div>

        {faqs && faqs.length > 0 && (<section className='bg-warm-50 pb-20 pt-12 md:pb-[72px]'>
            <h5 className='text-center font-medium md:hidden'>{t('faqs')}</h5>
            <h4 className='hidden text-center font-medium md:block'>
              {t('faqs')}
            </h4>
            <div className='container mt-8 flex justify-center'>
              <div className='-mx-2 -my-2 flex w-full max-w-[1120px] flex-col items-center justify-center '>
                {faqs.map((faq, index) => (<Collapsable key={index} type='faq' className='mx-2 my-2  w-full rounded-xl border border-solid border-cool-300 bg-cool-50 p-5 sm:p-8' title={faq.attributes.title ? (<Markdown className='font-medium sm:text-xl'>
                          {faq.attributes.title}
                        </Markdown>) : (<p>
                          Sorry, we don&apos;t have a question for this answer
                          yet. Try again later!
                        </p>)}>
                    <div className='mt-3 text-sm text-cool-600 sm:mt-4 sm:text-base'>
                      {faq.attributes.description ? (<Markdown className='custom-answer'>
                          {faq.attributes.description}
                        </Markdown>) : (<p>
                          Sorry, we don&apos;t have an answer yet. Try again
                          later!
                        </p>)}
                    </div>
                  </Collapsable>))}
              </div>
            </div>
          </section>)}
      </main>
    </>);
};
Guarantee.getLayout = (page: ReactElement) => (<BaseLayout style='off-white-bg'>{page}</BaseLayout>);
const getStaticProps: GetStaticProps = async () => ({ props: {} });
export default Guarantee;

    async function __Next_Translate__getStaticProps__19c477be4c8__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/how-it-works/guarantee',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19c477be4c8__ as getStaticProps }
  